import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, TransitionGroup as _TransitionGroup, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1735ad92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-header" }
const _hoisted_2 = {
  key: 0,
  class: "position-sticky d-flex flex-wrap mt-n1 ms-n2 mb-2"
}
const _hoisted_3 = {
  class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center",
  style: {"min-width":"15%"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Tour #: ")
const _hoisted_5 = { class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center" }
const _hoisted_6 = { class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Passengers: ")
const _hoisted_8 = {
  class: "fs-4 fw-bold",
  style: {"line-height":"16px"}
}
const _hoisted_9 = { class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Rooms: ")
const _hoisted_11 = {
  class: "fs-5 fw-bold",
  style: {"line-height":"16px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { title: "Double room count" }, "Dbl", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { title: "Single room count" }, "Sgl", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { title: "Triple room count" }, "Tpl", -1))
const _hoisted_15 = {
  class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center",
  style: {"min-width":"20%"}
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Tour Name: ")
const _hoisted_17 = {
  key: 0,
  class: "d-flex flex-wrap gap-2 mb-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-fill fs-6 fw-bold" }, [
  /*#__PURE__*/_createTextVNode(" IMPORTANT: This is a waiting list of signups only and is "),
  /*#__PURE__*/_createElementVNode("u", null, "NOT"),
  /*#__PURE__*/_createTextVNode(" the Rooming List."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Click a name to view/edit details. Drag a name to move between rooms. ")
], -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn btn-secondary text-uppercase",
    href: "/CMS/TripListPassengers"
  }, "Go Back")
], -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "d-flex flex-wrap" }
const _hoisted_23 = { class: "room-label" }
const _hoisted_24 = ["checked", "onInput"]
const _hoisted_25 = ["onDragenter", "onDrop"]
const _hoisted_26 = ["onDragstart"]
const _hoisted_27 = ["onMouseenter", "onMouseleave"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onMouseenter", "onMouseleave"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Full first and last name is required" }, "Name*:", -1))
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_36 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " Email: ", -1))
const _hoisted_38 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " Phone: ", -1))
const _hoisted_40 = ["readonly", "title", "value", "onMaska"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Home street address is required for one or more casinos on this tour" }, [
  /*#__PURE__*/_createTextVNode(" Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Line 1*: ")
], -1))
const _hoisted_42 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Line 2:")
], -1))
const _hoisted_44 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Home city and state is required for one or more casinos on this tour" }, " City, State*: ", -1))
const _hoisted_46 = { class: "d-flex" }
const _hoisted_47 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Home zip code is required for one or more casinos on this tour" }, " Zip*: ", -1))
const _hoisted_49 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Date of birth is required for one or more casinos on this tour" }, " Date of Birth*: ", -1))
const _hoisted_51 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Notes/ Requests:", -1))
const _hoisted_53 = ["readonly", "title", "onUpdate:modelValue"]
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  colspan: "2",
  class: "text-center"
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Request two beds: ")
const _hoisted_57 = ["readonly", "onUpdate:modelValue"]
const _hoisted_58 = {
  key: 0,
  class: "pax-container"
}
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-button-name" }, "Add Passenger", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-action pax-add" }, "+", -1))
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = {
  key: 0,
  class: "room-container room-new"
}
const _hoisted_64 = { class: "room-label" }
const _hoisted_65 = { class: "pax-container" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-button-name" }, "Add Passenger", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-action pax-add" }, "+", -1))
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmsHeader = _resolveComponent("CmsHeader")!
  const _component_CmsBreadcrumbs = _resolveComponent("CmsBreadcrumbs")!
  const _component_StateSelect = _resolveComponent("StateSelect")!
  const _component_ModalLoading = _resolveComponent("ModalLoading")!
  const _component_ModalErrorMessage = _resolveComponent("ModalErrorMessage")!
  const _component_ModalInfoMessage = _resolveComponent("ModalInfoMessage")!
  const _directive_focus = _resolveDirective("focus")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_CmsHeader, {
        "gt-url": '/' + _ctx.$route.params.gtUrl,
        "organization-name": _ctx.trip?.organizationName,
        email: _ctx.trip?.contactEmail
      }, null, 8, ["gt-url", "organization-name", "email"]),
      _createVNode(_component_CmsBreadcrumbs, {
        title: "Signups / Waiting List",
        crumbs: [{'title': 'Main Menu', 'url': '/CMS/Dashboard'}, {'title': 'Trip List', 'url': '/CMS/TripListPassengers'}, {'title': 'Trip Signups', 'url': ''}]
      }),
      (_ctx.trip && _ctx.signups)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("b", null, _toDisplayString(_ctx.trip.tourId), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("b", null, _toDisplayString(_ctx.tripDates), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.paxCount), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.doubleCount) + " ", 1),
                _hoisted_12,
                _createTextVNode(", " + _toDisplayString(_ctx.singleCount) + " ", 1),
                _hoisted_13,
                _createTextVNode(", " + _toDisplayString(_ctx.tripleCount) + " ", 1),
                _hoisted_14
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("b", null, _toDisplayString(_ctx.trip.tourName), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.trip && _ctx.signups)
      ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-primary text-uppercase", { 'animate-success': _ctx.animateSaved }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args))),
              onAnimationend: _cache[1] || (_cache[1] = ($event: any) => (_ctx.animateSaved = false))
            }, " Save ", 34)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-primary text-uppercase", { 'animate-success': _ctx.animateMoved }]),
              disabled: !_ctx.trip.canEditRoomingList,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveCheckedToRL && _ctx.moveCheckedToRL(...args))),
              onAnimationend: _cache[3] || (_cache[3] = ($event: any) => (_ctx.animateMoved = false)),
              title: "Move passengers in rooms that have been checked (to the right of the room title) to the confirmed Rooming List"
            }, " Move to Rooming List ", 42, _hoisted_19)
          ]),
          _hoisted_20
        ]))
      : _createCommentVNode("", true),
    (_ctx.trip && _ctx.signups)
      ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (roomPax, room, roomIdx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "room-container",
                key: room
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createTextVNode(" Room " + _toDisplayString(_ctx.roomNumToChar(roomIdx + 1)) + " - " + _toDisplayString(_ctx.roomType(roomPax.length)) + " ", 1),
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    checked: _ctx.allInRoomToBeMovedToRL(room),
                    onInput: ($event: any) => (_ctx.setRoomPaxToMoveToRL(room, $event.target.checked)),
                    title: "Check this box and then click 'Move to Rooming List' if you want to move all passengers in this room to the confirmed Rooming List"
                  }, null, 40, _hoisted_24)
                ]),
                _createElementVNode("div", {
                  class: "room-inner d-flex flex-wrap",
                  dropzone: "move",
                  onDragenter: ($event: any) => (_ctx.dragOver($event, room)),
                  onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                  onDragleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dragOut($event))),
                  onDrop: ($event: any) => (_ctx.dragDrop(room))
                }, [
                  _createVNode(_TransitionGroup, { name: "slide-fade" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomPax, (pax) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "pax-container",
                          draggable: "true",
                          onDragstart: ($event: any) => (_ctx.startDrag($event, pax)),
                          onDragend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.dragEnd && _ctx.dragEnd(...args))),
                          key: pax.clientId
                        }, [
                          _createElementVNode("div", {
                            class: "pax-button",
                            title: "Click to view/edit details. Drag to move to another room",
                            onMouseenter: ($event: any) => (_ctx.cancelHidePaxDetails($event.target, pax.clientId)),
                            onMouseleave: ($event: any) => (_ctx.hidePaxDetails($event.target, pax.clientId))
                          }, [
                            _createElementVNode("span", {
                              class: "pax-button-name",
                              onClick: ($event: any) => (_ctx.showPaxDetails($event.target.parentElement, pax.clientId))
                            }, _toDisplayString((pax.firstName || pax.lastName) ? `${pax.firstName} ${pax.lastName}` : "New Passenger"), 9, _hoisted_28),
                            (_ctx.hasRecordError(_ctx.fieldErrors, pax.clientId))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "pax-validation-status fw-bold bg-warning",
                                  onClick: ($event: any) => (_ctx.showPaxDetails($event.target.parentElement, pax.clientId)),
                                  draggable: "true",
                                  ondragstart: "return false;",
                                  title: "Click to view issues with these passenger details"
                                }, "!", 8, _hoisted_29))
                              : _createCommentVNode("", true),
                            (!pax.isViewed)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "pax-viewed-status bg-primary",
                                  onClick: ($event: any) => (_ctx.showPaxDetails($event.target.parentElement, pax.clientId)),
                                  draggable: "true",
                                  ondragstart: "return false;",
                                  title: "New Signup"
                                }, "N", 8, _hoisted_30))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: "pax-action pax-delete",
                              onClick: ($event: any) => (_ctx.removePassenger(pax)),
                              draggable: "true",
                              ondragstart: "return false;",
                              title: "Click to remove passenger"
                            }, "X", 8, _hoisted_31)
                          ], 40, _hoisted_27),
                          _createVNode(_Transition, {
                            name: "fade",
                            key: pax.clientId,
                            onBeforeEnter: _ctx.beforePaxDetailsFadeIn,
                            onAfterLeave: _ctx.afterPaxDetailsFadeOut
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", {
                                class: "pax-details",
                                onMouseenter: ($event: any) => (_ctx.showPaxDetails($event.target.previousElementSibling, pax.clientId)),
                                onMouseleave: ($event: any) => (_ctx.hidePaxDetails($event.target.previousElementSibling, pax.clientId)),
                                draggable: "true",
                                ondragstart: "return false;"
                              }, [
                                _createElementVNode("table", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_33,
                                    _createElementVNode("td", _hoisted_34, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        placeholder: "First Name",
                                        readonly: !_ctx.trip.canEditRoomingList,
                                        class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'FirstName', pax.clientId) }]),
                                        title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'FirstName', pax.clientId),
                                        autocomplete: "off",
                                        "onUpdate:modelValue": ($event: any) => ((pax.firstName) = $event)
                                      }, null, 10, _hoisted_35), [
                                        [_directive_focus],
                                        [
                                          _vModelText,
                                          pax.firstName,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        placeholder: "Last Name",
                                        readonly: !_ctx.trip.canEditRoomingList,
                                        class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'LastName', pax.clientId) }]),
                                        title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'LastName', pax.clientId),
                                        autocomplete: "off",
                                        "onUpdate:modelValue": ($event: any) => ((pax.lastName) = $event)
                                      }, null, 10, _hoisted_36), [
                                        [
                                          _vModelText,
                                          pax.lastName,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_37,
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "email",
                                        class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Email', pax.clientId) }]),
                                        readonly: !_ctx.trip.canEditRoomingList,
                                        title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Email', pax.clientId),
                                        "onUpdate:modelValue": ($event: any) => ((pax.email) = $event)
                                      }, null, 10, _hoisted_38), [
                                        [
                                          _vModelText,
                                          pax.email,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_39,
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "tel",
                                        class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Phone', pax.clientId) }]),
                                        readonly: !_ctx.trip.canEditRoomingList,
                                        title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Phone', pax.clientId),
                                        value: _ctx.formatPhone(pax.phone),
                                        placeholder: "(555) 123-4567",
                                        onMaska: ($event: any) => {{ if ((pax.phone ?? '') != ($event.target.dataset.maskRawValue ?? '')) pax.phone = $event.target.dataset.maskRawValue; }}
                                      }, null, 42, _hoisted_40), [
                                        [_directive_maska, '(###) ###-####']
                                      ])
                                    ])
                                  ]),
                                  (_ctx.trip?.casinoManifest)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("tr", null, [
                                          _hoisted_41,
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'AddressLine1', pax.clientId) }]),
                                              readonly: !_ctx.trip.canEditRoomingList,
                                              title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'AddressLine1', pax.clientId),
                                              "onUpdate:modelValue": ($event: any) => ((pax.addressLine1) = $event)
                                            }, null, 10, _hoisted_42), [
                                              [
                                                _vModelText,
                                                pax.addressLine1,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _hoisted_43,
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'AddressLine2', pax.clientId) }]),
                                              readonly: !_ctx.trip.canEditRoomingList,
                                              title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'AddressLine2', pax.clientId),
                                              "onUpdate:modelValue": ($event: any) => ((pax.addressLine2) = $event)
                                            }, null, 10, _hoisted_44), [
                                              [
                                                _vModelText,
                                                pax.addressLine2,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _hoisted_45,
                                          _createElementVNode("td", _hoisted_46, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'City', pax.clientId) }]),
                                              readonly: !_ctx.trip.canEditRoomingList,
                                              title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'City', pax.clientId),
                                              placeholder: "City",
                                              "onUpdate:modelValue": ($event: any) => ((pax.City) = $event)
                                            }, null, 10, _hoisted_47), [
                                              [
                                                _vModelText,
                                                pax.City,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ]),
                                            _createVNode(_component_StateSelect, {
                                              modelValue: pax.State,
                                              "onUpdate:modelValue": ($event: any) => ((pax.State) = $event),
                                              readonly: !_ctx.trip.canEditRoomingList,
                                              class: _normalizeClass({ 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'State', pax.clientId) }),
                                              title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'State', pax.clientId)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "class", "title"])
                                          ])
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _hoisted_48,
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'PostalCode', pax.clientId) }]),
                                              readonly: !_ctx.trip.canEditRoomingList,
                                              title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'PostalCode', pax.clientId),
                                              "onUpdate:modelValue": ($event: any) => ((pax.postalCode) = $event)
                                            }, null, 10, _hoisted_49), [
                                              [
                                                _vModelText,
                                                pax.postalCode,
                                                void 0,
                                                { trim: true }
                                              ],
                                              [_directive_maska, '#####']
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _hoisted_50,
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "date",
                                              class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'DateOfBirth', pax.clientId) }]),
                                              readonly: !_ctx.trip.canEditRoomingList,
                                              title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'DateOfBirth', pax.clientId),
                                              "onUpdate:modelValue": ($event: any) => ((pax.dateOfBirth) = $event)
                                            }, null, 10, _hoisted_51), [
                                              [
                                                _vModelText,
                                                pax.dateOfBirth,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ])
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("tr", null, [
                                    _hoisted_52,
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Notes', pax.clientId) }]),
                                        readonly: !_ctx.trip.canEditRoomingList,
                                        title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Notes', pax.clientId),
                                        "onUpdate:modelValue": ($event: any) => ((pax.notes) = $event)
                                      }, null, 10, _hoisted_53), [
                                        [
                                          _vModelText,
                                          pax.notes,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  (roomPax.length > 1)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                                        _createElementVNode("th", _hoisted_55, [
                                          _hoisted_56,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            readonly: !_ctx.trip.canEditRoomingList,
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event: any) => ((pax.twoBeds) = $event)
                                          }, null, 8, _hoisted_57), [
                                            [_vModelCheckbox, pax.twoBeds]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 40, _hoisted_32), [
                                [_vShow, _ctx.showingPaxDetailsId == pax.clientId]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onBeforeEnter", "onAfterLeave"])
                        ], 40, _hoisted_26))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024),
                  (roomPax.length < 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("div", {
                          class: "pax-button pax-button-add",
                          onClick: ($event: any) => (_ctx.addPassenger(room)),
                          title: "Click to add passenger"
                        }, _hoisted_62, 8, _hoisted_59)
                      ]))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_25)
              ]))
            }), 128)),
            (_ctx.roomCount < 200)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, " Room " + _toDisplayString(_ctx.roomNumToChar(_ctx.roomCount + 1)) + " - New Room ", 1),
                  _createElementVNode("div", {
                    class: "room-inner",
                    dropzone: "move",
                    onDragenter: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dragOver($event, _ctx.roomMax + 1))),
                    onDragover: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
                    onDragleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dragOut($event))),
                    onDrop: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dragDrop(_ctx.roomMax + 1)))
                  }, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", {
                        class: "pax-button pax-button-add",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addPassenger(_ctx.roomMax + 1))),
                        title: "Click to add passenger"
                      }, _hoisted_68)
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ModalLoading, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.errorMessage != null)
      ? (_openBlock(), _createBlock(_component_ModalErrorMessage, {
          key: 3,
          message: _ctx.errorMessage,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.errorMessage = null))
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_ctx.infoMessage != null)
      ? (_openBlock(), _createBlock(_component_ModalInfoMessage, {
          key: 4,
          message: _ctx.infoMessage,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.infoMessage = null))
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}